module.exports = "/_next/static/resources/photo-4-4c12b7778942f02f71742eda29faa97d.jpg";